import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './DestinationSelect.css';

class DestinationSelect extends Component {
  state = { open: false, search: '' };
  root = null;

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    if (this.state.open && this.root && !this.root.contains(event.target)) {
      this.close();
    }
  };

  close = () => this.setState({ open: false, search: '' });

  toggle = () => {
    if (this.props.disabled) return;
    this.state.open ? this.close() : this.setState({ open: true });
  };

  // Tooltip i18n key explaining why a destination cannot be picked, or null.
  // No credits wins over an IE mismatch when both apply.
  getDestinationBlock(destination) {
    if (destination.available_credits <= 0) return 'noCredits';
    if (
      Boolean(destination.ie_game_active) !== Boolean(this.props.sourceIeActive)
    ) {
      return 'ieMismatch';
    }
    return null;
  }

  select = (destination) => {
    if (this.getDestinationBlock(destination)) return;
    this.props.onChange(destination);
    this.close();
  };

  filteredDestinations() {
    const search = this.state.search.trim().toLowerCase();
    if (!search) return this.props.destinations;
    return this.props.destinations.filter((destination) =>
      destination.name.toLowerCase().includes(search),
    );
  }

  renderOption(destination) {
    const block = this.getDestinationBlock(destination);
    const selected = this.props.value && this.props.value.id === destination.id;
    return (
      <li
        key={destination.id}
        className={`select-option${block ? ' disabled' : ''}${
          selected ? ' selected' : ''
        }`}
        aria-disabled={Boolean(block)}
        onClick={() => this.select(destination)}
      >
        <span className="option-text">
          <span className="option-name">{destination.name}</span>
          <span className="option-credits">
            {I18n.t('campaigns.move.availableCreditsCount', {
              count: destination.available_credits,
            })}
          </span>
        </span>
        {block && (
          <OverlayTrigger
            placement="left"
            overlay={
              <Tooltip id={`move-${block}-${destination.id}`}>
                {I18n.t(`campaigns.move.${block}`)}
              </Tooltip>
            }
          >
            <span className="info-icon material-symbols-rounded">info</span>
          </OverlayTrigger>
        )}
      </li>
    );
  }

  render() {
    const { value, loading, disabled } = this.props;
    const { open, search } = this.state;
    return (
      <div
        className={`destination-select${disabled ? ' disabled' : ''}`}
        ref={(node) => {
          this.root = node;
        }}
      >
        <button
          type="button"
          className={`select-toggle${open ? ' open' : ''}${
            value ? ' has-value' : ''
          }`}
          disabled={disabled || loading}
          onClick={this.toggle}
        >
          <span className="toggle-text">
            {value ? value.name : I18n.t('campaigns.move.selectPlaceholder')}
          </span>
          <span className="material-symbols-rounded">expand_more</span>
        </button>
        {open && (
          <div className="select-options">
            <div className="select-search">
              <span className="material-symbols-rounded">search</span>
              <input
                type="text"
                autoFocus
                value={search}
                placeholder={I18n.t('campaigns.move.searchPlaceholder')}
                onChange={(event) =>
                  this.setState({ search: event.target.value })
                }
              />
            </div>
            <ul>
              {this.filteredDestinations().map((d) => this.renderOption(d))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

DestinationSelect.defaultProps = { destinations: [], sourceIeActive: false };
DestinationSelect.propTypes = {
  destinations: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  sourceIeActive: PropTypes.bool,
};

export default DestinationSelect;
